import { classNames } from '@repo/ui/src/utils/classNames';
import { headingClasses } from '@repo/ui/src/utils/styleUtils';
import { HeaderVariationProps } from '@repo/ui/src/types/headerVariation';

interface Props {
  subtitleAsDesc?: boolean;
  subtitle?: string;
  title?: string;
  headerVariation: HeaderVariationProps;
  darkMode: boolean;
  description?: string;
}

const TierTwoHeader = ({
  subtitleAsDesc,
  subtitle,
  title,
  headerVariation,
  darkMode,
  description,
}: Props) => {
  const Header = headerVariation?.headerVariation ?? 'h1';
  const newDesc = subtitleAsDesc ? subtitle : description;

  return (
    <>
      <div>
        {!subtitleAsDesc && subtitle && (
          <h2
            className={classNames(
              'tw-max-w-[600px] tra-text-web-sub-1 tw-pt-0 tw-pb-3 tw-m-auto',
              darkMode ? 'tw-text-white' : 'tw-text-black',
            )}
          >
            {subtitle}
          </h2>
        )}
        {title && (
          <Header
            className={classNames(
              'tra-text-web-heading-h1 tw-py-0',
              darkMode ? 'tw-text-white' : 'tw-text-black',
              headingClasses[Header],
            )}
          >
            {title}
          </Header>
        )}
      </div>
      {newDesc && (
        <p
          className={classNames(
            'tra-text-web-body-xl tw-max-w-[600px]',
            darkMode ? 'tw-text-white' : 'tw-text-black',
          )}
        >
          {newDesc}
        </p>
      )}
    </>
  );
};

export default TierTwoHeader;
